import axios from "axios";
import {
    Message,
    MessageBox
} from "element-ui";
import store from "../store";
import {
    getToken
} from "@/utils/token";
import { getAppBaseUrl} from './host'
import { getLanguage } from './../i18n/langs/index'
let baseUrl = window.location.href;
const service = axios.create({
    baseURL:getAppBaseUrl(),

    // baseURL: document.location.protocol + window.location.search,
    // baseURL: getAppBaseUrl(),
    // baseURL: 'http://invest.thinkey.org/',
    // baseURL: "http://192.168.1.108:8600",
});
service.interceptors.request.use(
    config => {
        // let token = "Bearer " + getToken();
        // config.headers["content-type"] = "application/json; charset=utf-8";
        // if (store.getters.token) {
        //     config.headers["Authorization"] = token;
        // }
        let token = getToken();
        if (token) {
            config.headers['token'] = getToken()
        }
        config.headers['Content-Type'] = 'application/json; charset=utf-8'
        // 设置请求的语言
    config.headers['locale'] = getLanguage();
        return config;
    },
    error => {
        Promise.reject(error);
    }
);
service.interceptors.response.use(
    response => {
        const res = response.data;
        if (
            response.data.code === undefined ||
            response.data.code === "" ||
            response.data.code === 201 ||
            response.data.code ==200||
            response.data.code === 513||
            response.data.code === 512||
            response.data.code === 500||
            response.data.code === 10000
        ) {
            return response.data;
        } else {
            if (res.code === 510) {
                store.dispatch("app/FedLogOut").then(() => {
                    location.reload();
                });
            }
            return Promise.reject(response.data);
        }
    },
    error => {
        let msg = "";
        if (error == "Error: timeout of 5000ms exceeded") {
            msg = "无效请求！请求超时！";
        } else {
            msg = error.message;
        }
        Message({
            message: msg,
            type: "error",
            duration: 2 * 1000
        });
        return Promise.reject(error);
    }
);

export default service;
